import AdminHOC from "../../../components/shared/HOC/AdminHOC";
import React, { useEffect, useState } from 'react';
import CustomBreadcrumb from "../../../components/shared/breadcrumbs/CustomBreadCrumb";
import { getDashboardStats } from "../../../service/AdminService/adminDashboardService";
import Back from '../../../assets/back-btn.svg';
import { useAdminDashboard } from "../../../hooks/AdminHooks/useAdminDashboard";
import DashboardStats from "./Components/DashboardStats";
import RecentDataTabs from "./Components/RecentDataTabs";
import { useSelector } from "react-redux";
import { formatRole } from "../../../utility/formatName";

const AdminDashboard = ({ setHeader, setBreadCrumbs }) => {
    const {
        userCount,
        bundleCount,
        courseCount,
        activeDomainCount,
        groupCount,
        enrollmentCount,
        recentUserList,
        recentGroupList,
        recentCourseList,
        recentBundleList,
        loading,
        error,
        refetch,
    } = useAdminDashboard();
    const auth = useSelector((state) => state.auth);

    useEffect(() => {
        refetch();
    }, []);

    return (
    <div className="flex flex-col gap-4 p-2.5">

        <div>
            <p className="font-medium text-[28px] text-[#E74860]"> Welcome {auth.fullName}</p>
            <p className="font-medium text-base text-[#464646]"> {formatRole(auth.roles[0])}</p>
        
        </div>
        <DashboardStats
            userCount={userCount}
            courseCount={courseCount}
            bundleCount={bundleCount}
            groupCount={groupCount}
            enrollmentCount={enrollmentCount}
            activeDomainCount={activeDomainCount}
            loading={loading}
            error={error}
        />
        <RecentDataTabs
            recentUserList={recentUserList}
            recentCourseList={recentCourseList}
            recentBundleList={recentBundleList}
            recentGroupList={recentGroupList}
            loading={loading}
        />
    </div>
);
};

export default AdminHOC(AdminDashboard);